import request from '@/utils/request'
// 活动
export function Activitylist() {//活动列
	return request({
		url:`/exam/activity/list`,
		method: 'get'
	})
}
export function Activityget(data) {//参与活动
	return request({
		url:`/exam/activity`,
		method: 'post',
		data:new URLSearchParams(data).toString()
	})
}